import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Chip, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import colors from 'common/constants/colors';

const FALLBACK_NOTE_BY_CONTACT_KIND = {
  email:
    "This patient's default email. Any partner without its own email for this patient sends " +
    'notifications here.',
  phone:
    "This patient's default phone number. Any partner without its own phone number for this " +
    'patient sends notifications here.',
};

// Marks the patient's own email or phone, which stands in for a partner that has none.
const DefaultContactChip = ({ contactKind }) => (
  // describeChild keeps the note out of the chip's name, which also names a form field it labels.
  <Tooltip title={FALLBACK_NOTE_BY_CONTACT_KIND[contactKind]} placement='top' describeChild>
    <Chip
      component='span'
      icon={<LocalOfferIcon aria-hidden />}
      label='Default'
      size='small'
      sx={{
        height: 17,
        fontSize: 11,
        fontWeight: 500,
        color: colors.defaultContactChipText,
        bgcolor: colors.defaultContactChipSurface,
        '& .MuiChip-icon': { fontSize: 11, color: 'inherit', ml: '6px', mr: '-3px' },
        '& .MuiChip-label': { px: '7px', lineHeight: '17px' },
      }}
    />
  </Tooltip>
);

DefaultContactChip.propTypes = {
  contactKind: PropTypes.oneOf(['email', 'phone']).isRequired,
};

export default DefaultContactChip;
